import styled from 'styled-components'

import MarkdownText from '../MarkdownText'
import Icon from '../Icon'
import ActionButton from '../ActionButton'
import breakpoints from '../../theme/breakpoints'

export const Container = styled.div`
  border-radius: 3rem;
  border: 1px solid ${({ theme }) => theme.colors.royalBlue};
  overflow: hidden;
  width: 100%;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-style: hidden;
`

export const TableHead = styled.thead`
  border: 1px solid ${({ theme }) => theme.colors.nightRider};
  background-color: ${({ theme }) => theme.colors.neonBlue};
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr<{ $isEditing?: boolean }>`
  & > td {
    color: ${({ $isEditing, theme }) =>
      $isEditing ? theme.colors.royalBlue : theme.colors.nightRider};
  }
`

export const TableHeader = styled.th`
  ${({ theme }) => theme.textStyles.textLargeStrong};
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.pureWhite};
  border: 1px solid ${({ theme }) => theme.colors.nightRider};
  padding: 1.6rem;
  text-align: start;
  &:first-child {
    width: 5%;
  }
  &:nth-child(2) {
    width: 85%;
  }
  &:last-child {
    width: 5%;
  }

  ${breakpoints.up('tablet')} {
    font-size: 1.6rem;
  }
`

export const TableCell = styled.td<{ $noPadding?: boolean }>`
  ${({ theme }) => theme.textStyles.textLarge};
  font-size: 1.4rem;
  border: 1px solid ${({ theme }) => theme.colors.nightRider};
  padding: ${({ $noPadding }) => ($noPadding ? '0' : '1.6rem')};
  text-align: start;

  ${breakpoints.up('tablet')} {
    font-size: 1.6rem;
  }
`

export const Markdown = styled(MarkdownText)``

export const DeclarationState = styled.span`
  display: flex;
  align-items: center;
`

export const StyledIcon = styled(Icon)`
  width: 2rem;
  height: 2rem;
  margin-left: 0.5rem;
  color: ${({ theme }) => theme.colors.royalBlue};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`

export const Action = styled(ActionButton)``

export const EditingFormWrapper = styled.div``
